var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "abnormalOrder" },
    [
      _c("Filtersearch", {
        ref: "Filtersearchref",
        attrs: { list: _vm.Filtersearchlist, fromdata: _vm.from },
        on: { Refresh: _vm.Refresh, search: _vm.search },
        scopedSlots: _vm._u([
          {
            key: "right",
            fn: function () {
              return [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "warning",
                      disabled: !_vm.tableData.length || _vm.disabledExport,
                      icon: "el-icon-upload2",
                    },
                    on: { click: _vm.onHandleExport },
                  },
                  [_vm._v("导出")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "auto-table-flex" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                height: "100%",
                border: true,
                "header-cell-style": {
                  color: "#333333",
                  background: "#EFF6FF",
                },
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  width: "100px",
                  align: "center",
                  label: "序号",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logistic_business_name",
                  align: "center",
                  label: "集配中心",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "order_no", align: "center", label: "订单编号" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "product_title",
                  align: "center",
                  label: "商品名称",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "qty", align: "center", label: "件数" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "gross_weight_total",
                  align: "center",
                  label: "吨数",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "supplier_title",
                  align: "center",
                  label: "供应商名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "buyer_name",
                  align: "center",
                  label: "采购名称",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "pay_at", align: "center", label: "支付时间" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "abnormal_order_type_name",
                  align: "center",
                  label: "类型",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logistics_name",
                  align: "center",
                  label: "城市仓",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "member_name",
                  align: "center",
                  label: "客户名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "member_mobile",
                  align: "center",
                  label: "客户电话",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              type: "primary",
              background: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": 10,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }